import { EMPTY } from 'rxjs';

export const waitingListState = {
  active: false,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  showPopup: (() => {}) as () => void
};

export function WaitingListGuard() {
  return function (_target: unknown, _key: string, descriptor: PropertyDescriptor) {
    const original = descriptor.value;
    descriptor.value = function (...args: unknown[]) {
      if (waitingListState.active) {
        waitingListState.showPopup();
        return EMPTY;
      }
      return original.apply(this, args);
    };
    return descriptor;
  };
}
